import { render, staticRenderFns } from "./ContentMail.vue?vue&type=template&id=236b74f8&"
import script from "./ContentMail.vue?vue&type=script&lang=js&"
export * from "./ContentMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports